/*
 * Public API Surface of slider
 */

export * from './lib/mx-slider.service';
export * from './lib/mx-slider.model';
export * from './lib/mx-slider.module';
